import React, { useEffect, useMemo, useState } from "react";
import styles from "./style.module.css";
import FromToPage from "../../components/FromToPage";
import BanerSlider from "../../components/BanerSlider";
import { useDispatch, useSelector } from "react-redux";
import ProductsWithSlide from "../../components/ProductsWithSlide";
import CategoryBlock from "../Hisense/categoryBlock";
import { getBrandPageInfo } from "../../store/MainSlice";
import langData from "../../lang/data";
import LoadContent from "../../components/LoadContent";
import { Link } from "react-router-dom";

const PRODUCTS_PER_SECTION = 8;

const extractCategories = (products) => {
  const seen = new Map();
  (products || []).forEach((p) => {
    const cats = p?.categories ?? p?.product?.categories ?? [];
    const cat = Array.isArray(cats) ? cats[0] : cats;
    if (cat && typeof cat === "object") {
      const key = cat.name_en ?? cat.name_hy ?? cat.name_ru ?? cat.slug ?? JSON.stringify(cat);
      if (!seen.has(key)) seen.set(key, { ...cat, _key: key });
    }
  });
  return Array.from(seen.values());
};

const filterByCategory = (products, category) => {
  if (!category || !products?.length) return products ?? [];
  const key = category._key ?? category.name_en ?? category.name_hy ?? category.name_ru ?? category.slug;
  return products.filter((p) => {
    const cats = p?.categories ?? p?.product?.categories ?? [];
    const first = Array.isArray(cats) ? cats[0] : cats;
    const catKey = first?.name_en ?? first?.name_hy ?? first?.name_ru ?? first?.slug;
    return catKey === key || (first?.id && category?.id && String(first.id) === String(category.id));
  });
};

const Samsung = () => {
  const dispatch = useDispatch();
  const { brand, currentLanguage } = useSelector(({ main }) => main);
  const [activeCategory2, setActiveCategory2] = useState(null);
  const [activeCategory3, setActiveCategory3] = useState(null);

  useEffect(() => {
    dispatch(getBrandPageInfo("samsung"));
  }, []);

  const allProducts2 = brand?.products_second_slider ?? [];
  const allProducts3 = brand?.products_third_slider ?? [];

  const categories2 = useMemo(() => extractCategories(allProducts2), [allProducts2]);
  const categories3 = useMemo(() => extractCategories(allProducts3), [allProducts3]);

  const filtered2 = useMemo(() => {
    const base = activeCategory2 ? filterByCategory(allProducts2, activeCategory2) : allProducts2;
    return base.slice(0, PRODUCTS_PER_SECTION);
  }, [allProducts2, activeCategory2]);

  const filtered3 = useMemo(() => {
    const base = activeCategory3 ? filterByCategory(allProducts3, activeCategory3) : allProducts3;
    return base.slice(0, PRODUCTS_PER_SECTION);
  }, [allProducts3, activeCategory3]);

  const getCatName = (cat) =>
    cat?.["name_" + currentLanguage] ?? cat?.name_hy ?? cat?.name_en ?? cat?.name_ru ?? cat?.name ?? "";

  useEffect(() => {
    if (categories2?.length && activeCategory2 === null) setActiveCategory2(categories2[0]);
  }, [categories2]);

  useEffect(() => {
    if (categories3?.length && activeCategory3 === null) setActiveCategory3(categories3[0]);
  }, [categories3]);

  const pages = useMemo(
    () => [{ label: brand?.brand.name, value: `/samsung`, active: true }],
    [brand?.brand.name]
  );

  return (
    <>
      <div className="wrapper">
        <FromToPage pages={pages} />
        <BanerSlider
          bannerSliders={brand?.slider1}
          imgStyle={{ maxHeight: "none" }}
        />
        <div className={styles.InfoAboutPage}>
          {!brand ? (
            <LoadContent containerClassName={styles.LoadContentGeneralBanner} />
          ) : (
            <element
              dangerouslySetInnerHTML={{
                __html: brand?.info?.["text_1_" + currentLanguage],
              }}></element>
          )}
        </div>
        <div className={styles.twoBanersBlck}>
          <a href={brand?.baners?.banner_1_href}>
            {!brand ? (
              <LoadContent
                containerClassName={styles.LoadContentTwoBanersBlck}
              />
            ) : (
              <img
                src={
                  process.env.REACT_APP_STORAGE_URL +
                  brand?.baners["baner_1_" + currentLanguage]
                }
                alt={""}
              />
            )}
          </a>
          <a href={brand?.baners?.banner_2_href}>
            {!brand ? (
              <LoadContent
                containerClassName={styles.LoadContentTwoBanersBlck}
              />
            ) : (
              <img
                src={
                  process.env.REACT_APP_STORAGE_URL +
                  brand?.baners["baner_2_" + currentLanguage]
                }
                alt={""}
              />
            )}
          </a>
        </div>
        <a href={brand?.baners?.banner_3_href}>
          <div className={styles.generalBanner}>
            {!brand ? (
              <LoadContent
                containerClassName={styles.LoadContentGeneralBanner}
              />
            ) : (
              <img
                src={
                  process.env.REACT_APP_STORAGE_URL +
                  brand?.baners["baner_3_" + currentLanguage]
                }
                alt={""}
              />
            )}
          </div>
        </a>
      </div>

      <div className="wrapper">
        <div className={styles.titleBlck}>
          <h1 className="title">{langData.titles.BestDealProduct[currentLanguage]}</h1>
          <Link
            to={`${currentLanguage !== "hy" ? "/" + currentLanguage : ""}/brand/samsung/category`}
            className={styles.topPicksProductBtn}>
            {langData.buttons.view_all[currentLanguage]}
          </Link>
        </div>
        {categories2?.length > 1 && (
          <div className={styles.promotionCategoryBlock}>
            {categories2.map((cat) => (
              <div
                key={cat._key}
                className={`${styles.categories} ${activeCategory2?._key === cat._key ? styles.categoriesActive : ""}`}
                onClick={() => setActiveCategory2(cat)}>
                {getCatName(cat)}
              </div>
            ))}
          </div>
        )}
      </div>
      <ProductsWithSlide productsData={filtered2} />

      <div className="wrapper">
        <BanerSlider
          containerStyle={{
            padding: 0,
            margin: "0px 0px 60px"
          }}
          imgStyle={{
            maxHeight: "none",
            borderRadius: "10px",
          }}
          bannerSliders={brand?.slider2}
        />
        {categories3?.length > 1 && (
          <div className={styles.promotionCategoryBlock}>
            {categories3.map((cat) => (
              <div
                key={cat._key}
                className={`${styles.categories} ${activeCategory3?._key === cat._key ? styles.categoriesActive : ""}`}
                onClick={() => setActiveCategory3(cat)}>
                {getCatName(cat)}
              </div>
            ))}
          </div>
        )}
        <CategoryBlock
          myData={filtered3}
          showMoreBtn={false}
          url={false}
        />
        <div className={styles.generalBannerSection}>
          <div className={styles.generalBanner}>
            {brand?.baners["baner_4_" + currentLanguage] ? (
              <a href={brand?.baners.banner_4_href}>
                <img
                  src={
                    process.env.REACT_APP_STORAGE_URL +
                    brand?.baners["baner_4_" + currentLanguage]
                  }
                  alt={""}
                />
              </a>
            ) : (
              <LoadContent
                containerStyle={{
                  height: "400px",
                }}
              />
            )}
          </div>
        </div>
        <CategoryBlock
          myData={brand?.products_last_slider}
          showMoreBtn={true}
          url={`${
            currentLanguage !== "hy" ? "/" + currentLanguage : ""
          }/brand/samsung/category`}
        />
        <div className={styles.lastInfoBrand}>
          <element
            dangerouslySetInnerHTML={{
              __html: brand?.info?.["text_2_" + currentLanguage],
            }}></element>
        </div>
      </div>
    </>
  );
};

export default Samsung;
